import ApiService from '@/services/apiService';
import { mapState, mapGetters } from 'vuex';

export default {
  data: function () {
    return {
      selectedTenantId: 0,
      tenants: [],
      hasLoadedTenants: false,
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled', 'permissions']),
    ...mapGetters({
      sessionPrimaryTenantIds: 'authentication/primaryTenantIds',
      sessionAccess: 'authentication/access',
    }),
    tenantModel() {
      return this.getTenantById(this.selectedTenantId) || { data: {} };
    },
    isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
  },
  methods: {
    loadTenants(filter = () => true, preselected) {
      if (!this.permissions['all.manage']) {
        return;
      }
      this.hasLoadedTenants = false;
      return Promise.all(
        this.sessionPrimaryTenantIds.map((tenantId) => {
          return ApiService.tenantGetById(tenantId, ['no-scope-descendents']).catch((error) => {
            if (error.response.status === 401) {
              // a simple 401 for 1 tenant should not cause the whole operation to "cancel"
              return null;
            }
            throw error;
          });
        })
      )
        .then((tenants) => {
          const proccessedTenants = tenants
            .filter((t) => t)
            .map((tenant) => {
              if (!tenant.data) {
                tenant.data = {};
              }
              return tenant;
            });
          this.tenants = [];
          this.buildTenantList(proccessedTenants, '', filter);
          if (this.tenants.length > 0) {
            if (preselected && this.getTenantById(preselected)) {
              this.selectTenant(preselected);
            } else {
              this.selectTenant(this.tenants[0].id);
            }
          }
          this.hasLoadedTenants = true;
          return true;
        })
        .catch((error) => {
          console.error(error);
          if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
            this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
          } else {
            this.$snack(this.$i18n_t('Common.tenantReadFail'), 'error');
          }
        });
    },
    selectTenant(id) {
      this.selectedTenantId = id;
    },
    buildTenantList(roots, indent = '', filter) {
      roots.forEach((root) => {
        if (!filter || filter(root)) {
          this.tenants.push({
            id: root.id,
            parentId: root.parentId,
            scopeId: root.scopeId,
            name: `${indent} ${root.name} (${this.$i18n_t('Common.id')}: ${root.id})`,
            data: root.data,
            properties: root.properties,
          });
        }
        root.children.forEach((element) => {
          if (!filter || filter(element)) {
            this.tenants.push({
              id: element.id,
              parentId: element.parentId,
              scopeId: element.scopeId,
              name: `${indent} ${element.name} (${this.$i18n_t('Common.id')}: ${element.id})`,
              data: element.data,
              properties: element.properties,
            });
            if (element.children) {
              this.buildTenantList([element], `${indent} ${element.name} > `, filter);
            }
          }
        });
      });
    },

    getTenantById(tenantId) {
      return this.tenants.find((item) => item.id === tenantId);
    },
    getTenantIdxById(tenantId) {
      return this.tenants.findIndex((item) => item.id === tenantId);
    },
  },
};
